export const scrollTop = (scrollElement, number) => {
  const element = document.getElementById(scrollElement ?? 'page-container');
  element.scrollTo({ top: number || 0 });
};
